import React from "react";
import { Accordion } from "rsuite";
import { Tabs, Tab } from "react-bootstrap";
import TableHeader from "@components/TableHeader";
import Printfiled from "./Printfiled";
const Transfer = (props) => {
  return (
    <>
      <Accordion defaultActiveKey={0} bordered className="bg-white">
        {props.prices.map((transfer, transferIndex) => (
          <PanelComponent
            transfer={transfer}
            transferIndex={transferIndex}
            t={props.t}
            config={props.config}
            priceForm={props.priceForm}
            onStopSales={props.onStopSales}
          />
        ))}
      </Accordion>
    </>
  );
};

const PanelComponent = ({
  transfer,
  transferIndex,
  t,
  config,
  priceForm,
  onStopSales,
}) => {
  return (
    <Accordion.Panel
      header={
        <div className="p-3">
          <span className="fs-8 ms-1" style={{ color: "gray" }}>
            {transfer.departure.name} ({transfer.departure.type}) -{" "}
            {transfer.arrival.name} ({transfer.arrival.type})
          </span>
        </div>
      }
      eventKey={transferIndex}
    >
      <Tabs defaultActiveKey={0} id="board-tabs" className="custom-tabs">
        {transfer.vehicles.map((vehicle, vehicleIndex) => (
          <Tab
            eventKey={vehicleIndex}
            title={vehicle.brand + " " + vehicle.model + " " + vehicle.type}
          >
            <PanelPrice
              transferIndex={transferIndex}
              prices={vehicle.prices}
              vehicleIndex={vehicleIndex}
              t={t}
              config={config}
              priceForm={priceForm}
              onStopSales={onStopSales}
            />
          </Tab>
        ))}
      </Tabs>
    </Accordion.Panel>
  );
};
const PanelPrice = ({
  transferIndex,
  prices,
  vehicleIndex,
  t,
  config,
  priceForm,
  onStopSales,
}) => {
  const header = [
    {
      title: "tarif_date",
      width: 7,
      align: "left",
      filed: "date",
    },
    {
      title: "availability",
      width: 8,
      align: "center",
      filed: "vehicle_available",
    },
    {
      title: "base_amount",
      width: 18,
      align: "center",
      filed: "base_amount",
      filedList: ["day_price", "night_price"],
    },
    {
      title: "charge",
      width: 18,
      align: "center",
      filed: "charge",
      filedList: ["day_price", "night_price"],
    },
    {
      title: "amount_traveler",
      width: 18,
      align: "center",
      filed: "amount_traveler",
      filedList: ["day_price", "night_price"],
    },
    {
      title: "you_earn",
      width: 18,
      align: "center",
      filed: "you_earn",
      filedList: ["day_price", "night_price"],
    },
    { title: "", width: 5, align: "center", filed: "is_stop_sales" },
    { title: "", width: 5, align: "center", filed: "button" },
  ];

  return (
    <div class="tableFixHead">
      <table>
        <TableHeader header={header} />
        <tbody>
          {prices.map((tarif, rowIndex) => (
            <tr key={rowIndex}>
              {header.map((head) => (
                <td
                  className="cell100"
                  style={{ width: head.width + "%", textAlign: head.align }}
                >
                  <Printfiled
                    tarif={tarif}
                    filed={head.filed}
                    filedList={head?.filedList}
                    onStopSales={onStopSales}
                    priceForm={priceForm}
                    config={config}
                    dataIndex={{
                      item: tarif,
                      index: rowIndex,
                      transferIndex: transferIndex,
                      vehicleIndex: vehicleIndex,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default Transfer;
